__turbopack_context__.v({
  "container": "MarketingSection-module-scss-module__eDJ01q__container",
  "ctas": "MarketingSection-module-scss-module__eDJ01q__ctas",
  "ctas-socials": "MarketingSection-module-scss-module__eDJ01q__ctas-socials",
  "marketing-sections-desktop": "MarketingSection-module-scss-module__eDJ01q__marketing-sections-desktop",
  "marketing-sections-mobile": "MarketingSection-module-scss-module__eDJ01q__marketing-sections-mobile",
  "socials": "MarketingSection-module-scss-module__eDJ01q__socials",
});
